module.exports = __webpack_public_path__ + "static/media/abe.acfd568d.jpeg";